"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotHandle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var DotHandle = function (_a) {
    var style = _a.style, highlight = _a.highlight, right = _a.right;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('squid-absolute -squid-z-10 squid-w-9 squid-h-9 -squid-top-5 squid-right-0  squid-rounded-full squid-flex squid-items-center squid-justify-center', highlight
            ? 'squid-bg-core-shadow-border-pressed-color'
            : 'squid-bg-transparent', right ? '-squid-mr-4' : '-squid-ml-4'), style: style }, { children: (0, jsx_runtime_1.jsx)("div", { className: "squid-border-2 squid-w-3 squid-h-3 squid-border-alias-color-border-active squid-bg-alias-color-bg-neutral squid-rounded-full" }) })));
};
exports.DotHandle = DotHandle;
